import { ResolverState } from '../resolvers/definition/resolverState';
import { Metrics } from '../metrics/metrics';
import { parseTypeName } from '../resources/resource';

export const createEmissionBuffer = ({
  onFlush,
  onFlushTypes,
}: {
  onFlush: (instanceKey: string, state: ResolverState<any>) => void;
  onFlushTypes: (typeNames: Set<string>) => void;
}) => {
  let pending = new Map<string, ResolverState<any>>();
  let flushScheduled = false;
  let readyAt = 0;

  const flush = () => {
    const batch = pending;
    pending = new Map();
    flushScheduled = false;

    if (readyAt > 0) {
      Metrics.timer('emissionBuffer.flushDelay').update(
        performance.now() - readyAt
      );
      readyAt = 0;
    }

    const typeNames = new Set<string>();
    for (const [instanceKey, state] of batch) {
      onFlush(instanceKey, state);
      typeNames.add(parseTypeName(instanceKey));
    }
    onFlushTypes(typeNames);
  };

  return {
    schedule: (instanceKey: string, state: ResolverState<any>) => {
      pending.set(instanceKey, state);

      if (!flushScheduled) {
        flushScheduled = true;
        queueMicrotask(flush);
      }
    },
    propagationFinished: () => {
      if (flushScheduled) {
        readyAt = performance.now();
      }
    },
  };
};

export type EmissionBuffer = ReturnType<typeof createEmissionBuffer>;
